import { take } from 'saga-ts';

export function* unityGuard() {
  console.time('unityGuard');
  yield take('UNITY_MODEL_LOADER');
  console.timeEnd('unityGuard');

  return true;
}
